export default __webpack_public_path__ + "static/kapcsoloszekreny-fcc0ebf7f57c14501efbc8c3971a867d.jpg";